import request from "./request";

export const _http = {
  // 业务数据总看板
  storeCountData(params) {
    return request({
      method: "POST",
      url: "/platform/pc/company/statistics/count",
      data: params,
    });
  },
  // top排行
  topRank(params) {
    return request({
      method: "POST",
      url: "/platform/pc/company/statistics/area",
      data: params,
    });
  },
  // 项目部数据对比
  statisticsCompany(params) {
    return request({
      method: "POST",
      url: "/platform/pc/company/statistics/company",
      data: params,
    });
  },
  // Excel-导出门店数据
  exportStatisticsExcel(params) {
    return request({
      method: "POST",
      url: "/platform/pc/company/statistics/excel",
      data: params,
      responseType: "blob",
    });
  },
  // 区域下拉列表
  getAreaSelect(params) {
    return request({
      method: "GET",
      url: "/platform/pc/company/statistics/getAreaSelect",
      params,
    });
  },
  // 门店下拉列表
  getStoreSelectList(params) {
    return request({
      method: "GET",
      url: "/platform/pc/company/statistics/getStoreSelectList",
      params,
    });
  },
  // 标签下拉列表
  getStoreTagSelect(params) {
    return request({
      method: "GET",
      url: "/platform/pc/company/statistics/getStoreTagSelect",
      params,
    });
  },
  // 门店数据
  storeStatisticsData(params) {
    return request({
      method: "POST",
      url: "/platform/pc/company/statistics/list",
      data: params,
    });
  },

  // 门店商家下拉列表
  getSelectList(params) {
    return request({
      method: "GET",
      url: "/platform/pc/company/statistics/getSelectList",
      params: params,
    });
  },
};
